import React from "react";
import T from "prop-types";

export default function InventoryQuantityCell({
  inventory,
  renderDummyValues,
  alignment = "right"
}) {
  return (
    <td className={`text-${alignment}`}>
      {renderDummyValues ? inventory.dummy.quantity : inventory.total_quantity}
    </td>
  );
}

InventoryQuantityCell.propTypes = {
  inventory: T.shape({}).isRequired,
  renderDummyValues: T.bool,
  alignment: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/InventoryQuantityCell/InventoryQuantityCell.jsx